<template>
  <fieldset class="tab tab-07 none-bg">
    <div class="heading-form a-center">
      <span class="number">7/10</span>
      <p class="c-yellow">สุขภาพทางการเงิน</p>
      <h2 class="heading-h2 c-white">
        คุณคาดว่าจะเกษียณ<span class="br767">ตอนอายุเท่าไหร่</span>
      </h2>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input h-txtlast">
            <label for="" class="icw-label overlabel">อายุเกษียณ</label>
            <InputPattern
              id="txtRetire"
              type="text"
              placeholder=""
              v-model="retire"
              @blur="validAge()"
              maxlength="2"
              :regExp="/^[0\D]*|\D*/g"
              pattern="\d*"
            />
            <label for="" class="icw-label overlabel txt-last">ปี</label>
            <p class="input-note c-remark">ระบุได้ตั้งแต่ 40 - 99 ปี</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="prevStep('tab-07', 'tab-06')"
      >
        ย้อนกลับ
      </button>
    </div>
    <button
      id="btnNextStepQ8"
      type="button"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>
  </fieldset>
</template>

<script>
import Vue from "vue";

import InputPattern from "vue-pattern-input";

import { my_storage } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";

export default {
  name: "QuestionStep2_Q7",
  components: {
    InputPattern
  },
  props: {
    QuestionType: String
  },
  data() {
    return {
      retire: my_storage(this.QuestionType, "retire")
    };
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    validAge() {
      if (this.retire < 40) {
        this.retire = 40;
      } else if (this.retire > 99) {
        this.retire = 99;
      }
    },
    beforeNextStep() {
      if (this.retire != "") {
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));
        this.nextStep("tab-07", "tab-08");
      }
    }
  },
  computed: {
    isPass() {
      return this.retire != "";
    }
  }
};
</script>
